import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { ISlotsState } from "@/app_redux/reducers/slices/auth/slots_slice";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import React from "react";
import { IFromTab } from "../../interface";
import PetInsuranceForms from "./PetInsuranceForms";

const formData = [
  {
    btnText: "Post Grooming Not Done",
    source: "POST",
  },
  {
    btnText: "Membership not bought",
    source: "MEMBERSHIP",
  },
  {
    btnText: "Service Not Given",
    source: "SERVICE",
  },
  {
    btnText: "Block Client",
    source: "BLOCK_CLIENT",
  },
  {
    btnText: "Inventory Helpdesk",
    source: "INVENTORY",
  },
  {
    btnText: "Insurance Interest Form",
    source: "INSURANCE",
  },
  {
    btnText: "Insurance Details",
    source: "INSURANCE_DETAILS",
  },
  {
    btnText: "Call Disposition Form (Sales team)",
    source: "CALL_DISPOSITION",
  },
  {
    btnText: "Refund Approval",
    source: "REFUND_APPROVAL",
  },
  {
    btnText: "BD: Repeat Task",
    source: "REPEAT_TASK",
  },
  {
    btnText: "Overdue Form",
    source: "OVERDUE_FORM",
  },
  {
    btnText: "Complex Case (Doctors Only)",
    source: "DOCTORS_ONLY",
  },
];

const FormTabComponent: React.FC<IFromTab> = () => {
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { routeState: slotstate } = useRouteInfo(getRouteKey("SLOTS", "id"));
  const { customerDetails, customerId, petDetails, customerMembershipStatus } =
    routeState.state as ICustomerProfileState;
  const { customerBookings } = slotstate.state as ISlotsState;
  const user = useAppSelector((state) => state.auth.user);
  const mappedClinicName = useAppSelector((state) => state.root.UIStates.mappedClinicName);

  const handelRedirectToGoogleForm = (MODULE: string) => {
    const client_id = customerId;
    const client_mobile = customerDetails?.mobile;
    const client_name = customerDetails?.name;
    const pet_name = petDetails?.name;
    const pet_id = petDetails?.id;
    const pet_species = petDetails?.pet_species_type_id;
    const clinicName = mappedClinicName || "";
    const appointmentType = (customerBookings && customerBookings?.data[0]?.subservice_details?.name) || "";
    const appointmentDate = (customerBookings && customerBookings?.data[0]?.booking_end_date) || "";
    const unique_id = customerId;

    let url = "";
    if (MODULE === "POST") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSf-uNJLyP7UPJE1eE_2eY7QG-0gtkbehcecvcjWi7-XfxeKVg/viewform?usp=pp_url&entry.1422379=${client_name}&entry.657941237=${client_id}&entry.406957647=${pet_name}&entry.1175576812=${pet_id}&entry.513269039=${appointmentDate}&entry.1964930696=${clinicName}&entry.1622064667=${appointmentType}`;
    } else if (MODULE === "SERVICE") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSchOkufgQm9dC1hP_drkFBySoBbjyvV2DEPJqVOxVCT6nPEPA/viewform?usp=pp_url&entry.683484130=${client_name}&entry.1914162699=${pet_name}&entry.881427304=${unique_id}&entry.844793845=${client_mobile}&entry.223007323=${clinicName}&entry.383927314=${customerMembershipStatus ? "Member" : "Non Member"}&entry.1555006011=${appointmentType}`;
    } else if (MODULE === "DESK") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSf1kkZxCkrQU3TagezQLUVTuLXNZAgdYOx845X9MqYMole-IQ/viewform?usp=pp_url&entry.302312503=${client_name}&entry.670472768=${client_mobile}&entry.977074291=${pet_name}`;
    } else if (MODULE === "STOCK") {
      url = `/app/inventory/stock-incomplete-form?name_of_requester=${user?.email}&client_name=${client_name}&client_mobile=${client_mobile}&client_id=${client_id}&unique_id=${unique_id}`;
    } else if (MODULE === "MEMBERSHIP") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSfDbqoC1tA4zFIkGZX4w0YL5XFHDI9vr310CLS-Zq1WPsvYdA/viewform?usp=pp_url&entry.1422379=${client_name}&entry.657941237=${unique_id}&entry.406957647=${pet_name}&entry.1175576812=${pet_id}&entry.1622064667=${appointmentType}`;
    } else if (MODULE === "BLOCK_CLIENT") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSctgG-LisxcjPCj3rywP5xTczmOWykBzbehFPdA_4yPFE5AoQ/viewform?usp=pp_url&entry.1140403590=${client_name}&entry.1108381190=${unique_id}&entry.2047084738=${pet_name}&entry.967885550=${client_mobile}`;
    } else if (MODULE === "INVENTORY") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSc4rsmfkklyjNpBjUN8RmpyIxGr0eq8IfH6KDQe-KMFXyCOIg/viewform`;
    } else if (MODULE === "INSURANCE") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSfy_X9YZBMENmkUdj5hjpYg4SWlbDZXu-NC8fEWWzsOd6pjDA/viewform?usp=pp_url&entry.387976171=${client_name}&entry.1160639033=${client_mobile}&entry.2129163483=${pet_name}&entry.162347939=${pet_species === "1" ? "Dog" : "Cat"}&entry.1519105360=${appointmentDate}`;
    } else if (MODULE === "INSURANCE_DETAILS") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSd5gMtZUBH9GB07e_SPxTVnjosKO-lNeUObPmo8mDJz5e8MPw/viewform`;
    } else if (MODULE === "CALL_DISPOSITION") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLScQT5mhF851SkC8bcPO52CrWIchSOdgmh2wDGNUPFRmSVeGZw/viewform?usp=pp_url&entry.1870077981=${client_name}&entry.439134935=${pet_name}&entry.781290677=${client_mobile}`;
    } else if (MODULE === "INJURY_REPORTING") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLScJt8HYdNU2L6GkoYgPcHUCmeWnMiPIPSo9vJ1i4qp0k98axQ/viewform?usp=pp_url&entry.683484130=${client_name}&entry.844793845=${client_mobile}&entry.659570470=${pet_name}&entry.1327371762=${appointmentDate}`;
    } else if (MODULE === "REFUND_APPROVAL") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSdqnAulR0SaanePEnEAQubPMggXewn0lLqYs-6C-Ky_68F5GA/viewform?usp=pp_url&entry.1046451272=${pet_name}&entry.942772711=${pet_id}&entry.1139716827=${client_name}&entry.2065454471=${unique_id}`;
    } else if (MODULE === "OVERDUE_FORM") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSd2n5T4woUFoQa5KQsMe8MdMHxFl2VFV0E8CG--uxce2A3Z5w/viewform?usp=pp_url&entry.744966676=${clinicName}&entry.942772711=${client_name}&entry.1139716827=${client_mobile}&entry.2065454471=${client_id}`;
    } else if (MODULE === "REPEAT_TASK") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSfZwSu8tUwedRONQNCBSZWHjpU0uv7DcxmWPrL9o-OOb6sseQ/viewform?usp=pp_url&entry.1310661118=${client_mobile}&entry.2117420766=${pet_name}`;
    } else if (MODULE === "DOCTORS_ONLY") {
      url = `https://docs.google.com/forms/d/e/1FAIpQLSf53Zeu2sKL3iKtmPAE4FeTw5mQsGeswqOFRZynmZSxGL3Cdw/viewform?usp=pp_url&entry.642540983=${user?.email}&entry.2077852777=${pet_name}&entry.1294758464=${client_id}&entry.2104075106=${client_name}`
    }
    window.open(url, "_blank");
  };

  return (
    <div className="p-2">
      <p className="text-sm font-semibold">Form</p>
      <div className="grid grid-cols-1 gap-3 pt-2 sm:grid-cols-2 xl:grid-cols-4">
        {formData?.map((item) => {
          return (
            <button
              key={item.source}
              type="button"
              className="text-xs sm:text-xs 2xl:text-sm border px-3 py-3 rounded-md flex items-center gap-3 hover:border-[#0068FF] hover:bg-[#0068FF]/5"
              onClick={() => handelRedirectToGoogleForm(item.source)}
            >
             
              <span className="flex-1 text-left">{item.btnText}</span>
              <ArrowTopRightOnSquareIcon className="h-4 w-4 shrink-0" />
            </button>
          );
        })}
      </div>

      <PetInsuranceForms customerId={customerId} />
    </div>
  );
};

export default FormTabComponent;
